// extracted by mini-css-extract-plugin
export default {"zoomModal":"UZ-z","image":"VZ-z","button":"WZ-z","isOverlayShown":"XZ-z"};